import { useState } from "react";

export const C = {
  red:"#E8341A", dark:"#080808", mid:"#111111", card:"#181818",
  border:"#252525", text:"#F5F5F5", muted:"#666666", subtle:"#3A3A3A",
  green:"#16A34A", greenLight:"#22C55E", amber:"#F59E0B", blue:"#3B82F6",
};

export const Sheet = ({ open, onClose, children }) => (
  <div onClick={e => e.target === e.currentTarget && onClose()}
    style={{ position:"fixed", inset:0, background: open?"rgba(0,0,0,0.9)":"transparent", zIndex:200, display:"flex", alignItems:"flex-end", pointerEvents: open?"all":"none", transition:"background 0.25s" }}>
    <div style={{ background:C.mid, borderRadius:"24px 24px 0 0", width:"100%", maxHeight:"93vh", overflowY:"auto", padding:"20px 16px 52px", borderTop:`1px solid ${C.border}`, transform: open?"translateY(0)":"translateY(100%)", transition:"transform 0.35s cubic-bezier(0.32,0.72,0,1)" }}>
      <div style={{ width:36, height:4, background:C.subtle, borderRadius:2, margin:"0 auto 20px" }} />
      {children}
    </div>
  </div>
);

export const Btn = ({ onClick, children, variant="ghost", size="md", full=false, style={} }) => {
  const [hover, setHover] = useState(false);
  const sizes = { sm:{ padding:"7px 14px", fontSize:12, borderRadius:9 }, md:{ padding:"12px 20px", fontSize:14, borderRadius:12 }, lg:{ padding:"16px 24px", fontSize:16, borderRadius:14, width: full?"100%":undefined } };
  const variants = {
    red:{ background: hover?"#C42A12":C.red, color:"#fff", border:"none" },
    ghost:{ background:"transparent", color: hover?C.text:C.muted, border:`1px solid ${hover?C.subtle:C.border}` },
    danger:{ background:"transparent", color:"#ef4444", border:"1px solid #ef4444" },
    green:{ background: hover?"#15803d":C.green, color:"#fff", border:"none" },
    blue:{ background: hover?"#2563eb":C.blue, color:"#fff", border:"none" },
  };
  return (
    <button onClick={onClick} onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
      style={{ fontFamily:"inherit", cursor:"pointer", fontWeight:600, transition:"all 0.15s", display:"inline-flex", alignItems:"center", justifyContent:"center", gap:8, ...sizes[size], ...variants[variant], ...style }}>
      {children}
    </button>
  );
};

export const Input = ({ value, onChange, placeholder, type="text", rows }) => {
  const style = { width:"100%", background:"#0D0D0D", border:`1.5px solid ${C.border}`, borderRadius:12, padding:"13px 16px", color:C.text, fontFamily:"inherit", fontSize:14, outline:"none", lineHeight:1.6, boxSizing:"border-box" };
  return rows
    ? <textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows} style={{ ...style, resize:"none" }} />
    : <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={style} />;
};

export const Label = ({ children }) => (
  <div style={{ fontSize:11, fontWeight:700, color:C.muted, textTransform:"uppercase", letterSpacing:"0.7px", marginBottom:8 }}>{children}</div>
);

export const Toggle = ({ checked, onChange }) => (
  <div onClick={()=>onChange(!checked)} style={{ width:42, height:26, background: checked?C.green:"#2a2a2a", borderRadius:13, position:"relative", cursor:"pointer", transition:"background 0.2s", flexShrink:0 }}>
    <div style={{ position:"absolute", top:3, left: checked?19:3, width:20, height:20, background:"#fff", borderRadius:"50%", transition:"left 0.2s" }} />
  </div>
);

export const Badge = ({ color, children }) => {
  const map = {
    green:{bg:"#0f2a10",border:"#1e4a20",text:C.greenLight},
    red:{bg:"#2a0f0f",border:"#4a1e1e",text:"#f97316"},
    amber:{bg:"#1a1a08",border:"#3a3a10",text:C.amber},
    blue:{bg:"#0f1a2a",border:"#1e3a5a",text:C.blue},
    grey:{bg:"#1a1a1a",border:C.border,text:C.muted},
    danger:{bg:"#2a0a0a",border:"#5a1a1a",text:"#ef4444"},
  };
  const c = map[color]||map.grey;
  return <span style={{ background:c.bg, border:`1px solid ${c.border}`, color:c.text, padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>{children}</span>;
};

export const Stat = ({ label, value, sub, accent }) => (
  <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:13, padding:14, borderBottom:`3px solid ${accent}` }}>
    <div style={{ fontSize:10, textTransform:"uppercase", letterSpacing:"0.6px", color:C.muted, marginBottom:7, fontWeight:700 }}>{label}</div>
    <div style={{ fontSize:26, fontWeight:800, lineHeight:1, color:C.text }}>{value}</div>
    {sub && <div style={{ fontSize:11, color:C.muted, marginTop:5 }}>{sub}</div>}
  </div>
);

export const Topbar = ({ right, left, onLogoClick }) => (
  <div style={{ background:C.mid, borderBottom:`1px solid ${C.border}`, padding:"14px 16px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
    {left || <div onClick={onLogoClick} style={{ fontSize:16, fontWeight:900, letterSpacing:"-0.3px", cursor: onLogoClick?"pointer":"default" }}><span style={{ color:C.red }}>Quote</span><span style={{ color:C.text }}>MyBodywork</span></div>}
    {left && <div onClick={onLogoClick} style={{ fontSize:15, fontWeight:900, position:"absolute", left:"50%", transform:"translateX(-50%)", cursor: onLogoClick?"pointer":"default" }}><span style={{ color:C.red }}>Quote</span><span style={{ color:C.text }}>MyBodywork</span></div>}
    {right || <div />}
  </div>
);

export const BottomNav = ({ tabs, active, onSelect }) => (
  <div style={{ position:"fixed", bottom:0, left:0, right:0, background:C.mid, borderTop:`1px solid ${C.border}`, display:"flex", zIndex:100 }}>
    {tabs.map(t => (
      <button key={t.id} onClick={()=>onSelect(t.id)} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", padding:"10px 4px 16px", cursor:"pointer", color: active===t.id?C.red:C.muted, fontSize:10, gap:4, border:"none", background:"transparent", fontFamily:"inherit", position:"relative", fontWeight: active===t.id?700:400 }}>
        {t.count>0 && <span style={{ position:"absolute", top:6, right:"calc(50% - 17px)", background:C.red, color:"#fff", fontSize:9, padding:"1px 5px", borderRadius:8, fontWeight:800, minWidth:14, textAlign:"center" }}>{t.count}</span>}
        <span style={{ fontSize:22, lineHeight:1 }}>{t.icon}</span>
        <span>{t.label}</span>
      </button>
    ))}
  </div>
);

export const Divider = () => <div style={{ height:1, background:C.border, margin:"18px 0" }} />;

export const Stars = ({ n=5 }) => <span style={{ color:"#FBBF24", fontSize:14 }}>{"★".repeat(n)}</span>;

export const isValidUKPhone = (phone) => {
  const cleaned = (phone||"").replace(/[\s\-().]/g,"");
  return /^(07\d{9}|447\d{9}|\+447\d{9}|00447\d{9})$/.test(cleaned);
};
